import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=5df788b0&"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports